import React, {useState, useEffect} from 'react';
import axios from "axios";

const Salvataggio_dei_dati = (props) => {


    useEffect(() => {
      console.log('useEffect Call_php_iniziale')
      if (props.aggiornamento) {
        chiamata_file_php_utente ()
        chiamata_file_php_utente_todos()
        props.funzione_set_aggiornamento(false)
      }
      // Good!
    }, [props.aggiornamento]);

    const chiamata_file_php_utente = () => {
          axios({
            method: "post",
            url: 'https://www.idroslab.com/react_video_jobs/lista_file_salva.php',
            headers: { "content-type": "application/json" },
            data: props.utente
          }).then(data => {
            console.log('Salvataggio automatico file')
            console.log(data.data)
          }
          ).catch(err => {
              console.log('errore in axios')
              console.log(err)
              return null
        })
    };

    const chiamata_file_php_utente_todos = () => {
      var new_todos = {cognome: props.utente.cognome, nome: props.utente.nome, vettore: props.todos}   

      axios({
        method: "post",
        url: 'https://www.idroslab.com/react_video_jobs/lista_file_salva_todo.php',
        headers: { "content-type": "application/json" },
        data: new_todos
      }).then(data => {
        console.log('Salvataggio automatico file')
        console.log(data.data)
      }
      ).catch(err => {
          console.log('errore in axios')
          console.log(err)
          return null
    })
  };
    
    return (
        <div>
       
        </div>
        )

  }

  export default Salvataggio_dei_dati;